export const API_BASE_URL = "https://api.bigfanz.com";

// export const API_BASE_URL = "http://localhost:3000";

export const STRIPE_PUBLISHABLE_KEY =
  "pk_test_51OzgZ4HLU38l5lGn7f55bAyQUzpyfWkibKWgPUYKyq9CrmCKJM2Bl1aPSFMqC968gVpiBJBM6g2qdphZYTQ2hL2B008JrYJSTb";
